// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__fp9ZL","label":"CategoryService_label__3Rqw0","location":"CategoryService_location__OKwac"};